import PropTypes from 'prop-types';

import { Navigate } from 'react-router';

import { connect } from 'react-redux';

import { FIRST_CONSULTATION_ROUTE } from '../constants';

import Signup from '../Scenes/Signup';

import * as userActions from 'dux/user/actions';
import * as userSelectors from 'dux/user/selectors';

import signIn from '../questions/shared/signIn';

const getUserValues = values => ({
  email: values.email,
  first_name: values.firstName,
  last_name: values.lastName,
  has_accepted_terms: true,
});

const AcceptTermsContainer = ({ isLoading, patchUser, user }) => {
  if (!isLoading && user.has_accepted_terms) {
    return <Navigate replace to={FIRST_CONSULTATION_ROUTE} />;
  }

  return (
    <Signup
      acceptTermsMode
      content={signIn}
      handleSubmit={async values => {
        patchUser(getUserValues(values));
      }}
      initialValues={{
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
      }}
      questionIndex={2}
    />
  );
};

AcceptTermsContainer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  patchUser: PropTypes.func.isRequired,
  user: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    has_accepted_terms: PropTypes.bool,
  }).isRequired,
};

export default connect(
  state => ({
    isLoading: userSelectors.getUserIsLoading(state),
    user: userSelectors.getUser(state),
  }),
  {
    patchUser: userActions.patchUser,
  }
)(AcceptTermsContainer);
